import { Injectable } from '@angular/core';
declare var THREE: any;
import { StageService } from './stage.service';
import { SceneUtilsService } from './scene-utils.service';
import { ComponentBase } from '../component-base';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';

@Injectable()
export class RemoveStairsService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private railingGenerationService: RailingGenerationService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {
    super();
    this.disable();
    this.dataForDisplayingMenuItemsService.needStairRemove.subscribe(stair => {
      this.removeStair(stair);
    })
  }

  sprites = [];
  loader = new THREE.TextureLoader();
  isActive = false;
  intermediateStair: any;
  bottomStair: any;
  stairsPositions: any = [];
  angle: any;
  private raycaster: any = new THREE.Raycaster();

  drawSprites() {
    let stairs = this.stage.getStairs();

    for (var i = 0; i < stairs.length; i++) {
      var spriteMap = this.loader.load('../../assets/images/sprites/remove.png');

      var spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      var sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.stair = stairs[i];

      this.sprites.push(sprite);
      this.sprites[i].position.copy(stairs[i].children[0].position);
      this.stage.add(this.sprites[i]);
    }
  }

  mouseDown(e) {
    var p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    var intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      let stair = intersection[0].object.userData.stair;

      this.removeStair(stair);
      this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());

      this.removeSprites();
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites = [];
  }

  removeStair(stair) {
    stair.userData.config.firstPoint.superstructureType = null;
    stair.userData.config.firstPoint.distance = null;
    stair.userData.config.firstPoint.superstructureId = null;
    stair.userData.config.firstPoint.floorId = null;
    stair.parent.remove(stair);
  }

  disable() {
    this.removeSprites();
    super.disable();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/remove-stairs.service.ts